<script>
	import formBase from '@_system/components/base/form.vue'
	export default {
		extends: formBase,
		name: 'customizedproductorderForm',
		props: {

		},
		data() {
			return {

			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			beforeInit(next){
				next()
			},
			regestEvent(rule, fApi) {
				let purchasestaffid = window.systemData.staff.filter((item)=>{
					return item.departmentid == 35 && item.enable == 5
				})
				fApi.updateRule('purchasestaffid', {
					type: '$select',
					options:purchasestaffid.map((item)=>{
						return {
							value:item.id,
							label:item.name,
						}
					}),
					props: {}
				})
			},
			salercpt_noButton(){
				let salercpt_no = this.fApi.getValue('salercpt_no')
				if(!salercpt_no){
					this.$message.error('请输入XD编码')
					return
				}
				this.loading = true
				this.$api.customizedproductorder.listtrade({salercpt_no:salercpt_no}).then((res)=>{
					this.fApi.setValue('amount',res.tp_total)
					this.loading = false
				},()=>{
					this.loading = false
				})
			}
		},
		components: {

		}
	}
</script>
